<ng-container [formGroup]="form">
    <div class="row mb-4">
        <div class="col-2 form-group d-flex justify-content-center">
            <div class="form-check form-checkbox">
                <input
                  mdbCheckbox
                  class="form-check-input form-checkbox-input"
                  type="checkbox"
                  value=""
                  id="oneTime"
                  formControlName="oneTime"
                />
                <label class="form-check-label form-checkbox-label" for="oneTime">
                    OneTime
                </label>
              </div>
        </div>
        <div class="col-2 form-group d-flex justify-content-center">
            <div class="form-check form-checkbox">
                <input
                  mdbCheckbox
                  class="form-check-input form-checkbox-input"
                  type="checkbox"
                  value=""
                  id="weekly"
                  formControlName="weekly"
                />
                <label class="form-check-label form-checkbox-label" for="weekly">
                    Weekly
                </label>
              </div>
        </div>
        <div class="col-2 form-group d-flex justify-content-center">
            <div class="form-check form-checkbox">
                <input
                  mdbCheckbox
                  class="form-check-input form-checkbox-input"
                  type="checkbox"
                  value=""
                  id="monthly"
                  formControlName="monthly"
                />
                <label class="form-check-label form-checkbox-label" for="monthly">
                    Monthly
                </label>
              </div>
        </div>
        <div class="col-2 form-group d-flex justify-content-center">
            <div class="form-check form-checkbox">
                <input
                  mdbCheckbox
                  class="form-check-input form-checkbox-input"
                  type="checkbox"
                  value=""
                  id="quarterly"
                  formControlName="quarterly"
                />
                <label class="form-check-label form-checkbox-label" for="quarterly">
                    Quarterly
                </label>
              </div>
        </div>
        <div class="col-2 form-group d-flex justify-content-center">
            <div class="form-check form-checkbox">
                <input
                  mdbCheckbox
                  class="form-check-input form-checkbox-input"
                  type="checkbox"
                  value=""
                  id="semiAnnual"
                  formControlName="semiAnnual"
                />
                <label class="form-check-label form-checkbox-label" for="semiAnnual">
                    SemiAnnual
                </label>
              </div>
        </div>
        <div class="col-2 form-group d-flex justify-content-center">
            <div class="form-check form-checkbox">
                <input
                  mdbCheckbox
                  class="form-check-input form-checkbox-input"
                  type="checkbox"
                  value=""
                  id="annual"
                  formControlName="annual"
                />
                <label class="form-check-label form-checkbox-label" for="annual">
                    Annual
                </label>
              </div>
        </div>
    </div>
</ng-container>
